<template>
  <button
    :class="[
      'button',
      `button_${type}`,
      { 'button_disabled': disabled || isLoading }
    ]"
    :type="tagType"
    @click="onClick"
  >
    <span class="button__text">
      <slot />
    </span>
  </button>
</template>

<script>
  export default {
    name: 'BaseButton',
    props: {
      tagType: { // html type attr
        type: String,
        default: 'button'
      },
      type: {
        type: String,
        default: 'main',
        validator (type) {
          return type === 'main' ||
            type === 'secondary'
        }
      },
      disabled: {
        type: Boolean,
        default: false
      },
      isLoading: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      onClick () {
        if (this.disabled) return
        this.$emit('click')
      }
    }
  }
</script>

<style lang="scss">
  .button {
    position: relative;
    min-width: 180px;
    padding: 18px 60px 18px 24px;
    text-align: left;
    cursor: pointer;
    border: none;
    outline: none;
    transition: 0.4s;
    transform-origin: 50% 50%;

    &:active {
      transform: scale(0.95);
    }

    &::before {
      position: absolute;
      top: calc(50% - 1px);
      left: calc(100% - 49px);
      display: inline-block;
      width: 0;
      height: 1px;
      content: '';
      background-color: $c-white;
      transition: all 0.4s;
    }

    &::after {
      position: absolute;
      top: calc(50% - 1px);
      right: 24px;
      display: inline-block;
      width: 25px;
      height: 1px;
      content: '';
      background-color: $c-white;
      transition: all 0.4s;
    }

    @include hover {
      &::after {
        width: 7px;
      }

      &::before {
        width: 3px;
      }
    }

    &_main {
      background-color: $c-black;

      .button__text {
        color: $c-white;
      }
    }

    &_secondary {
      min-width: 136px;
      padding: 0;
      padding-right: 35px;
      background-color: $c-white;

      .button__text {
        color: $c-black;
      }

      &::before {
        z-index: -1;
      }

      &::after {
        right: 0;
        background-color: $c-black;
      }
    }

    &__text {
      font-family: "FavoritC", Arial, Helvetica, sans-serif;
      font-size: 12px;
      line-height: 15.46px;
      text-transform: uppercase;
      letter-spacing: 1.5px;
    }

    &_disabled {
      pointer-events: none;
      opacity: 0.5;
    }
  }
</style>
